import { Component, Inject, OnInit, HostBinding, HostListener } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InvoiceService } from '../services/invoice.service';
import { MessageService } from '../services/message.service';
import { PaymentMethodEnum, PaymentTypeEnum, SolutionTypeEnum, CardProcessorTypeEnum } from '../models/lookups.enum';
import { InvoiceModel, InvoiceItemModel, Activity, OrderModel, OrderItemModel, ManualPaymentResponseModel } from '../models/invoice.model';

import * as moment from 'moment';

export interface DialogData {
	payModuleTitle: string;
	solutionTypeId: number;
	activeInvoice: InvoiceModel;
	totalAmountDueInclTax: number;
	orderItems: OrderItemModel[];
	selectedOrderKey: string;
	orderRefNumber: string;
	clientPaymentProfile: any;
}

@Component({
	selector: 'payment-options-modal',
	templateUrl: 'payment-options.modal.html',
})
export class PaymentOptionsModal implements OnInit {

	public formSubmitMethod: string = 'POST';
	public isProcessing: boolean = false;
	public isCancelled: boolean | null = false;
	public solutionTypeEnum: SolutionTypeEnum = new SolutionTypeEnum();
	public cardProcessorTypes: CardProcessorTypeEnum = new CardProcessorTypeEnum();
	public payMethods: PaymentMethodEnum = new PaymentMethodEnum();
	public blockUnload: boolean = true;

	@HostListener('window:beforeunload', ['$event']) onBeforeUnload(event: BeforeUnloadEvent) {
		if (this.blockUnload) {
			event.preventDefault();
			event.returnValue = '';
			return false;
		}
	}

	constructor(public dialogRef: MatDialogRef<PaymentOptionsModal>, @Inject(MAT_DIALOG_DATA) public data: DialogData, public invoiceService: InvoiceService, public _messageService: MessageService, private _snackBar: MatSnackBar) {
	}

	onNoClick(): void {
		this.dialogRef.close();
	}

	ngOnInit() {
		this.isProcessing = false;
	}

	public submitForm() {
		this.isProcessing = true;
	}

	public getNowDate() {
		var nowDate = moment().toDate();
		return nowDate;
	}

	public close(event: any) {
		this.dialogRef.close({ solutionTypeId: this.data.solutionTypeId, activeInvoice: this.data.activeInvoice, responseParams: event});
	}

	public popSnackBar(message: string, action: string) {
		this._snackBar.dismiss();
		this._snackBar.open(message, action, { duration: 3500 });
	}
}